import { createSelector, createSlice } from '@reduxjs/toolkit';
import { getID } from '../room/roomSlice';

export const roomsSlice = createSlice({
  name: 'rooms',
  initialState: {
    rooms: {},
  },
  reducers: {
    addRoom: (state, action) => {
      const payload = action.payload;
      state.rooms[payload.id] = payload;
    },
  },
});

export const { addRooms } = roomsSlice.actions;

export const getRoom = (state, id) => state.rooms.rooms[id] ?? null;

export const getRoomIDsSorted = createSelector(
  [
    (state) => state.rooms.rooms,
  ],
  (rooms) => {
    return Object.values(rooms).sort((a, b) => {
      return a.room_order - b.room_order;
    }).map((p) => p.id);
  }
);

export const getMainTabState = (state) => {
  return (Object.values(state.rooms.rooms).length > 0) ? 2 : 1;
};

export const getCurrentRoom = (state) => {
  const id = getID(state);
  if (id === null) {
    return null;
  }
  return state.rooms.rooms[id];
}

export default roomsSlice.reducer;
